import { atom } from 'recoil';

export const companyState = atom<string | null>({
  key: 'companyState',
  default: null,
});
